import React from "react";
import {SurveySectionRefProvider} from "./SurveySectionRefProvider";
import {useLocation} from "react-router-dom";

const SurveyContentContainer = (props) => {
    const location = useLocation();
    return (
        <div className={props.homePage ? "sectionContainer homePage" : "sectionContainer"} id="section-to-print">
            {props.subtext &&
                <p dangerouslySetInnerHTML={{ __html: props.subtext }} ></p>
            }
            <SurveySectionRefProvider 
                key={location.pathname} 
                shouldShowSectionNavPanel={!props.homePage}
            >
                {props.children}
            </SurveySectionRefProvider>
        </div>
    );
};
export default SurveyContentContainer;


